export default "__VITE_ASSET__BNMyd0vM__"